import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { setSupportNav, getCategories, getDocStudies } from '../../actions/supportActions';

// import { SUPPORT_LEFT_NAV_ITEMS } from '../../constants';

import LeftNav from '../../components/support/LeftNav';
import ContactUs from '../../components/support/ContactUs';
import UserGuides from '../../components/support/UserGuides';
import StudyResources from '../../components/support/StudyResources';
import Releases from '../../components/support/Releases';
import Insights from '../../components/support/Notifications/Insights';
import Studies from '../../components/support/Notifications/Studies';
import { UPDATE_STUDY_STORAGE_KEY } from '../../constants';


class Support extends Component {
  state = {
    categories: [],
  }

  componentDidMount() {
    this.getStudies();
    getCategories(this.props.isTPAccount)
      .then(response => {
        this.setState({ categories: response }, () => {
          const updatedStudyPopup = localStorage.getItem(UPDATE_STUDY_STORAGE_KEY)
          if (this.props.isTPAccount || updatedStudyPopup) {
            this.updateSupportNav('Resources', 'Study Resources');
          } else {
            this.updateSupportNav('Resources', 'User Guides');
          }
        });
      });
  }

  componentWillUnmount() {
    if (this.props.isTPAccount) {
      this.updateSupportNav('Resources', 'Study Resources');
    } else {
      this.updateSupportNav('Resources', 'User Guides');
    }
  }

  getStudies = () => {
    this.props.getDocStudies()
  }


  getCategories = (parent, children) => {
    const { categories } = this.state;
    let categoryItem = categories[parent];
    if (children) {
      categoryItem = _.find(categoryItem.children, b => b.name === children);
    }
    return categoryItem;
  }

  updateSupportNav = (parent, child) => {
    this.props.setSupportNav(parent, child);
  }


  renderSupportView = () => {
    const { navItems } = this.props;

    let renderView = '';
    if (navItems) {
      const activeNavItem = navItems.find(item => item.active);
      const activeNav = activeNavItem.children.length > 0
        ? activeNavItem.activeChild
        : activeNavItem.name;
      // console.log(activeNav);
      switch (activeNav) {
        case 'User Guides': {
          const categoryItem = this.getCategories(activeNavItem.name, activeNavItem.activeChild);
          renderView = (
            <UserGuides category={categoryItem} />
          );
          break;
        }
        case 'Study Resources': {
          const categoryItem = this.getCategories(activeNavItem.name, activeNavItem.activeChild);
          renderView = (
            <StudyResources category={categoryItem} />
          );
          break;
        }
        case 'Releases': {
          const categoryItem = this.getCategories(activeNavItem.name, false);
          renderView = (
            <Releases category={categoryItem} setSupportNav={this.updateSupportNav} />
          );
          break;
        }
        case 'Insights': {
          const categoryItem = this.getCategories(activeNavItem.name, activeNavItem.activeChild);
          renderView = (
            <Insights category={categoryItem} />
          );
          break;
        }
        case 'Studies': {
          const categoryItem = this.getCategories(activeNavItem.name, activeNavItem.activeChild);
          renderView = (
            <Studies category={categoryItem} />
          );
          break;
        }
        case 'Contact Us':
          renderView = <ContactUs />;
          break;
        default:
          renderView = <div>No Resources found.</div>;
      }
    }

    return renderView;
  }


  render() {
    const { navItems } = this.props;
    const { categories } = this.state;

    if (_.isEmpty(categories)) {
      return (
        <div className="mri-support">
          <div className="mri-support-container">
            loading....
          </div>
        </div>
      );
    }

    if (_.isEmpty(navItems)) {
      return null;
    }

    return (
      <div className="mri-support">
        <div className="mri-support-container">
          <div className="mri-support-left-nav">
            <h3 className="mri-support--header">Support</h3>
            <nav className="mri-support-navigation">
              <LeftNav navItems={navItems} setSupportNav={this.updateSupportNav} />
            </nav>
          </div>
          <main className="mri-support-main">
            {this.renderSupportView()}
          </main>
        </div>
      </div>
    );
  }
}

Support.propTypes = {
  setSupportNav: PropTypes.func,
  getDocStudies: PropTypes.func,
  navItems: PropTypes.instanceOf(Array),
  isTPAccount: PropTypes.bool,
};

const mapStateToProps = ({ support, account }) => {
  return {
    navItems: support.navItems,
    isTPAccount: account.isTPAccount
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setSupportNav: bindActionCreators(setSupportNav, dispatch),
    getDocStudies: bindActionCreators(getDocStudies, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Support);

